import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WeeklyTimetableComponent } from './components/weekly-timetable/weekly-timetable.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { MobileWeeklyTimetableComponent } from './components/mobile-weekly-timetable/mobile-weekly-timetable.component';

@NgModule({
  imports: [
    CommonModule,
    SwiperModule
  ],
  declarations: [WeeklyTimetableComponent, MobileWeeklyTimetableComponent]
})
export class TimetableModule { }
